// extracted by mini-css-extract-plugin
module.exports = {"content":"_VAUH5-RX","heading":"_jDo_lQlz","subheading":"_mfH5dfEQ"};